import React from 'react';
import { Box, Typography, Grid, Button, IconButton } from '@mui/material';
import { Facebook, YouTube, Twitter, LinkedIn, Instagram } from '@mui/icons-material';
import XIcon from '@mui/icons-material/X';
import TikTokIcon from '@mui/icons-material/MusicNote'; // Placeholder for TikTok

const BlockFooter = () => {
    return (
        <Box sx={{ backgroundColor: 'white', color: '#333', p: 2 }}>
            <Box
                sx={{
                    borderTop: '1px solid #707070',
                    mt: 0,
                    mb: { xs: 4.5, sm: 0 },
                    // mb: 0,
                    pt: 2,
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Typography
                    variant="body2"
                    sx={{
                        fontFamily: 'Poppins',
                        fontWeight: 300,
                        fontSize: { xs: '12px', sm: '14px' },
                        textAlign: { xs: 'center', sm: 'left' },
                    }}
                >
                    © 2025 Travyx Technologies LTD. All rights reserved | Powered by AI
                </Typography>

                <Box sx={{ mt: { xs: 1, sm: 0, mt: 20 } }}>
                    <IconButton
                        component="a"
                        href="https://www.instagram.com/travyx_official/"
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{ color: '#333' }}
                    >
                        <Instagram />
                    </IconButton>

                    <IconButton
                        component="a"
                        href="https://www.facebook.com/people/travyxcom/61576313437957/"
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{ color: '#333' }}
                    >
                        <Facebook />
                    </IconButton>

                    <IconButton
                        component="a"
                        href="https://www.tiktok.com/@travyx_official"
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{ color: '#333' }}
                    >
                        <TikTokIcon />
                    </IconButton>

                    <IconButton
                        component="a"
                        href="https://www.youtube.com/@travyx_official"
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{ color: '#333' }}
                    >
                        <YouTube />
                    </IconButton>

                    <IconButton
                        component="a"
                        href="https://www.linkedin.com/company/107155688"
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{ color: '#333' }}
                    >
                        <LinkedIn />
                    </IconButton>
                </Box>
            </Box>
        </Box>
    );
};

export default BlockFooter;
